import React from "react";
import ELEMENTS from "./elements";

function Componentize(originProps) {
    const { element /*, parent */, variables } = originProps;

    let { name, attrs, props, children } = element;

    let newProps = { ...props, variables };
    attrs = { "data-element-name": name, "data-element-id": newProps.id, ...attrs };

    if (!ELEMENTS.hasOwnProperty(name)) {
        console.warn(`Unknown element '${name}'`);
        return null;
    }

    const Component = ELEMENTS[name];

    const parentVariables = { ...variables };
    for (const key in newProps) {
        parentVariables[key] = newProps[key];
    }

    const v2b = variables.variables2block?.filter(v2b => v2b.id === element.props.id)[0];
    if (v2b) {
        for (const key in v2b.variables) {
            parentVariables[key] = v2b.variables[key];
        }
    }

    newProps.variables = parentVariables;
    children && (newProps.children = Recursive(children, parentVariables));

    return <Component {...newProps} attrs={attrs} />;
}

function Recursive(structure, variables) {
    if (Array.isArray(structure)) {
        return structure.map(element => {
            if (element?.props?.id === undefined) {
                console.log(`[DeepBuild.jsx] [ERROR] element.props.id is undefined!`, element);
                throw new Error(`element.props.id is undefined!`);
            }

            return <Componentize key={element.props.id} {...{ variables, element, elements: structure }} />;
        });
    } else {
        if (structure?.props?.id === undefined) {
            console.log(`[DeepBuild.jsx] [ERROR] structure.props.id is undefined!`, structure);
            throw new Error(`structure.props.id is undefined!`);
        }

        return <Componentize key={structure.props.id} {...{ variables, element: structure }} />;
    }
}

export default function DeepBuildRoot(structure = [], variables = {}) {
    return Recursive(structure, variables);
}
